export default class BaseHelper {
  constructor() {  
  }
  static defaultConfig = {}
  static init() {}
  static update() {}
  static beforeDraw () {}
  static draw () {}
  static afterDraw () {}
  
}
